<template>
  <v-container>
    <QuickNavigation :fileData="fileData" :routeHistory="$route" />
    <section v-if="!!response && !!fileData">
      <section v-if="response.status == 200">
        <v-card flat>
          <v-simple-table dense class="table--bordered table--striped">
            <template v-slot:default>
              <thead>
                <tr class="primary">
                  <td class="white--text">Type</td>
                  <td class="white--text">Name</td>
                  <th class="white--text">Company</th>
                  <td class="white--text">Work #</td>
                  <td class="white--text">Mobile #</td>
                  <td class="white--text">Email</td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(contact, i) in contactCategoryList"
                  :key="'contact' + i"
                >
                  <td>
                    {{ contact.displayName }}
                  </td>
                  <td>
                    <div class="d-flex align-center">
                      <span>
                        {{
                          fileData.parties.find(
                            (x) => x.categoryId == contact.categoryId
                          ).firstName
                        }}
                        {{
                          fileData.parties.find(
                            (x) => x.categoryId == contact.categoryId
                          ).lastName
                        }}
                      </span>
                      <v-spacer></v-spacer>
                      <v-btn
                        v-if="contact.editable"
                        icon
                        @click="dialog = true"
                      >
                        <v-icon small> mdi-pencil </v-icon>
                      </v-btn>
                    </div>
                  </td>
                  <td>
                    {{
                      fileData.parties.find(
                        (x) => x.categoryId == contact.categoryId
                      ).company
                    }}
                  </td>
                  <td style="width: 15%">
                    <span
                      v-if="
                        fileData.parties.find(
                          (x) => x.categoryId == contact.categoryId
                        ).workPhone
                      "
                    >
                      {{
                        fileData.parties.find(
                          (x) => x.categoryId == contact.categoryId
                        ).workPhone | VMask($store.state.mask.phone)
                      }}
                    </span>
                  </td>
                  <td style="width: 15%">
                    <span
                      v-if="
                        fileData.parties.find(
                          (x) => x.categoryId == contact.categoryId
                        ).homePhone
                      "
                    >
                      {{
                        fileData.parties.find(
                          (x) => x.categoryId == contact.categoryId
                        ).homePhone | VMask($store.state.mask.phone)
                      }}
                    </span>
                  </td>
                  <td>
                    <a
                      v-if="
                        fileData.parties.find(
                          (x) => x.categoryId == contact.categoryId
                        ).email
                      "
                      :href="`mailto:${
                        fileData.parties.find(
                          (x) => x.categoryId == contact.categoryId
                        ).email
                      }`"
                      class="secondary--text"
                    >
                      {{
                        fileData.parties.find(
                          (x) => x.categoryId == contact.categoryId
                        ).email
                      }}
                    </a>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
        <v-dialog v-model="dialog" persistent width="600">
          <v-card v-if="fileData">
            <v-form ref="form" @submit.prevent="updateFileData">
              <v-card-title class="d-flex align-center lightgrey pa-2">
                <span class="text-h6"> Update Contact Information </span>
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="4">
                    <v-subheader>Post Closer (CORR)</v-subheader>
                  </v-col>
                  <v-col cols="8">
                    <v-select
                      v-model="fileData.otherUser16Name"
                      :items="assignee.postCloserList"
                      solo
                      dense
                      hide-details="auto"
                    ></v-select>
                  </v-col>

                  <v-col cols="4">
                    <v-subheader>Funder (CORR)</v-subheader>
                  </v-col>
                  <v-col cols="8">
                    <v-select
                      v-model="fileData.otherUser17Name"
                      :items="assignee.funderCorrList"
                      solo
                      dense
                      hide-details="auto"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  type="submit"
                  color="primary"
                  text
                  :loading="dialogLoading"
                >
                  Update
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </section>
      <section v-else class="error--text">
        {{ response }}
      </section>
    </section>
    <section v-else>
      <v-skeleton-loader type="table-tbody"></v-skeleton-loader>
    </section>
    <LoanDetailSubMenu />
  </v-container>
</template>

<script>
import QuickNavigation from "@/components/QuickNavigation";
import LoanDetailSubMenu from "@/components/LoanDetailSubMenu";
import { convert } from "@/mixins";

export default {
  name: "Contact",
  components: {
    QuickNavigation,
    LoanDetailSubMenu,
  },
  async mounted() {
    this.response = await this.$store
      .dispatch("fileDataApi/getFileDataDetail", {
        loanNumber: this.$route.query.loanNumber,
        option: "AllWithOutEmbeddedDocs",
      })
      .catch((err) => err);

    if (this.response.status !== 200) {
      this.$store.commit("statusDialog/showErrorDialog", this.response.data);

      this.$router.go(-1);
    }

    this.contactCategoryList = await this.getContactCategoryList();
    this.fileData = this.response.data;

    const assignedUserList = await this.$store
      .dispatch("user/getUserProfiles")
      .then((resp) => resp.data)
      .catch((err) => err);

    this.assignee.postCloserList = assignedUserList
      .filter((x) => x.role === 536870912)
      .map((x) => x.userName);

    this.assignee.postCloserList.unshift("");

    this.assignee.funderCorrList = assignedUserList
      .filter((x) => x.role === 1073741824)
      .map((x) => x.userName);

    this.assignee.funderCorrList.unshift("");
  },
  data() {
    return {
      response: null,
      fileData: null,
      contactCategoryList: null,
      dialog: false,
      dialogLoading: false,
      assignee: {
        postCloserList: [],
        funderCorrList: [],
      },
    };
  },
  methods: {
    async getContactCategoryList() {
      let contact = [
        { categoryId: 600, displayName: "Submission", editable: false },
        { categoryId: 102, displayName: "Account Executive", editable: false },
        { categoryId: 106, displayName: "Account Manager", editable: false },
        { categoryId: 4, displayName: "Underwriter", editable: false },
        { categoryId: 601, displayName: "DOC Drawer", editable: false },
        { categoryId: 3, displayName: "Funder", editable: false },
        { categoryId: 44, displayName: "Escrow Company", editable: false },
        { categoryId: 40, displayName: "Title Company", editable: false },
        { categoryId: 110, displayName: "Broker", editable: false },
        { categoryId: 1, displayName: "Loan Officer", editable: false },
        { categoryId: 2, displayName: "Loan Processor", editable: false },
        {
          categoryId: 108,
          displayName: "Broker Loan Processor",
          editable: false,
        },
        { categoryId: 22, displayName: "Selling Agent", editable: false },
        { categoryId: 21, displayName: "Listing Agent", editable: false },
        { categoryId: 25, displayName: "Builder", editable: false },
      ];

      if (this.isCorrChannel()) {
        contact.push({
          categoryId: 621,
          displayName: "Post Closer (CORR)",
          editable: true,
        });
        contact.push({
          categoryId: 622,
          displayName: "Funder (CORR)",
          editable: true,
        });
      }

      return contact;
    },
    async updateFileData() {
      try {
        this.dialogLoading = true;
        if (this.$refs.form.validate()) {
          const ret = await this.$store.dispatch("fileDataApi/updateFileData", {
            fileData: this.toOriginTypeFileData(this.fileData),
            fileDataId: this.fileData.fileDataId,
          });

          if (ret.status == 200) {
            this.fileData = ret.data;
          } else {
            throw ret.data;
          }
        }
      } catch (err) {
        console.log(err);
        this.$store.commit(
          "statusDialog/showErrorDialog",
          "Sorry, the update failed."
        );
      } finally {
        this.dialogLoading = false;
        this.dialog = false;
      }
    },
    isCorrChannel() {
      return this.$store.state.userOrgProfile.originationChannel === 5;
    },
  },
  mixins: [convert],
};
</script>
